import * as React from 'react';
import { useRecordContext, TextField } from 'react-admin';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default React.memo((props: any) => {
  const record = useRecordContext();
  return <TextField source="name" className={`name-level-${record.level}`} />;
});
